/** The browser tab's title: the open screen's registry `title`, then the brand ("Today · Field Day"). */
import { useEffect } from 'react'
import { matchPath } from 'react-router'

export function documentTitle(screenTitle: string | undefined, appName: string): string {
  const app = appName.trim() || 'Operations'
  return screenTitle ? `${screenTitle} · ${app}` : app
}

/** The registered screen at this path (or a path under it), if any. */
export function screenForPath<S extends { path: string }>(screens: S[], pathname: string): S | undefined {
  return screens.find((s) => matchPath({ path: s.path, end: false }, pathname))
}

export function setDocumentTitle(title: string, doc: { title: string } = document) {
  if (doc.title !== title) doc.title = title
}

export function useDocumentTitle(title: string) {
  useEffect(() => setDocumentTitle(title), [title])
}
